export default "__VITE_ASSET__2edDwR2E__"